import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { AxiosError } from 'axios';
import { useContext, useContextSelector } from 'use-context-selector';
import { ConsolidatedTransactions } from '../../domain/Transaction/entities/ConsolidatedTransaction/ConsolidatedTransactionResponseDTO';
import { ConsolidatedTransactionsContext } from './ConsolidatedTransactionsContext';

const useConsolidatedTransactionsState = () => {
  const context = useContext(ConsolidatedTransactionsContext);

  if (context === undefined) {
    throw new Error('useConsolidatedTransactionsState must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useConsolidatedTransactions = () => {
  const context = useContextSelector(
    ConsolidatedTransactionsContext,
    state => state.consolidatedTransactionListData?.transactions ?? [],
  );

  if (context === undefined) {
    throw new Error('useConsolidatedTransactions must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useConsolidatedTransactionsTotalItems = () => {
  const context = useContextSelector(
    ConsolidatedTransactionsContext,
    state => state.consolidatedTransactionListData?.totalItems ?? 0,
  );

  if (context === undefined) {
    throw new Error('useConsolidatedTransactionsTotalItems must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useResetConsolidatedTransactionListFilters = () => {
  const context = useContextSelector(
    ConsolidatedTransactionsContext,
    state => state.resetConsolidatedTransactionsListFilters,
  );

  if (context === undefined) {
    throw new Error('useResetConsolidatedTransactionListFilters must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useOnConsolidatedTransactionListFiltersChange = () => {
  const context = useContextSelector(
    ConsolidatedTransactionsContext,
    state => state.onConsolidatedTransactionListFiltersChange,
  );

  if (context === undefined) {
    throw new Error(
      'useOnConsolidatedTransactionListFiltersChange must be used within ConsolidatedTransactionsProvider',
    );
  }

  return context;
};

const useConsolidatedTransactionListFilters = () => {
  const context = useContextSelector(
    ConsolidatedTransactionsContext,
    state => state.consolidatedTransactionListFilters,
  );

  if (context === undefined) {
    throw new Error('useConsolidatedTransactionListFilters must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useConsolidatedTransactionsProviderLoadingState = (loadingProperty: 'isLoadingConsolidatedTransactionList') => {
  const context = useContextSelector(ConsolidatedTransactionsContext, state => state.loadingState[loadingProperty]);

  if (context === undefined) {
    throw new Error(
      'useConsolidatedTransactionsProviderLoadingState must be used within ConsolidatedTransactionsProvider',
    );
  }

  return context;
};

const useConsolidatedTransactionsProviderErrorState = (
  errorProperty: 'consolidatedTransactionListError',
): AxiosError<APIGatewayResponse<ConsolidatedTransactions>, any> | null => {
  const context = useContextSelector(ConsolidatedTransactionsContext, state => state.errorState[errorProperty] ?? null);

  // if (context === undefined) {
  //   throw new Error(
  //     'useConsolidatedTransactionsProviderErrorState must be used within ConsolidatedTransactionsProvider',
  //   );
  // }

  return context;
};

const useRefetchConsolidatedTransactionList = () => {
  const context = useContextSelector(
    ConsolidatedTransactionsContext,
    state => state.refetchConsolidatedTransactionList,
  );

  if (context === undefined) {
    throw new Error('useRefetchConsolidatedTransactionDetails must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useGetLastPaginationPageVisited = () => {
  const context = useContextSelector(ConsolidatedTransactionsContext, state => state.lastPaginationPageVisited);
  if (context === undefined) {
    throw new Error('useGetLastPaginationPageVisited must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

const useOnSetLastPaginationPageVisited = () => {
  const context = useContextSelector(ConsolidatedTransactionsContext, state => state.onSetLastPaginationPageVisited);
  if (context === undefined) {
    throw new Error('useOnSetLastPaginationPageVisited must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

export {
  useConsolidatedTransactionsState,
  useConsolidatedTransactions,
  useConsolidatedTransactionsTotalItems,
  useConsolidatedTransactionsProviderLoadingState,
  useConsolidatedTransactionsProviderErrorState,
  useResetConsolidatedTransactionListFilters,
  useOnConsolidatedTransactionListFiltersChange,
  useConsolidatedTransactionListFilters,
  useRefetchConsolidatedTransactionList,
  useGetLastPaginationPageVisited,
  useOnSetLastPaginationPageVisited,
};
